export interface BillingActionTypes {
  type: BillingActions;
  payload?: any;
}

export enum BillingActions {
  GET_BILLING_LIST = "GET_BILLING_LIST",
  SET_BILLING_LIST = "SET_BILLING_LIST",
  SET_BILLING_LIST_PAGE_COUNT = "SET_BILLING_LIST_PAGE_COUNT",
  GENERATE_BILLING = "GENERATE_BILLING",
  SET_GENERATED_BILLING = "SET_GENERATED_BILLING",
  GET_BILLING_DATA_BY_ID = "GET_BILLING_DATA_BY_ID",
  SET_BILLING_DATA_BY_ID = "SET_BILLING_DATA_BY_ID",
  EDIT_BILLING_DATA_BY_ID = "EDIT_BILLING_DATA_BY_ID",
  DELETE_BILLING = "DELETE_BILLING",
  GET_BILLING_HISTORY = "GET_BILLING_HISTORY",
  SET_BILLING_HISTORY = "SET_BILLING_HISTORY",
  SET_BILLING_HISTORY_PAGE_COUNT = "SET_BILLING_HISTORY_PAGE_COUNT",
  GET_BILLING_HISTORY_BY_ID = "GET_BILLING_HISTORY_BY_ID",
  SET_BILLING_HISTORY_BY_ID = "SET_BILLING_HISTORY_BY_ID",
  CLEAR_BILLING_HISTORY_BY_ID = "CLEAR_BILLING_HISTORY_BY_ID",
}
